import React, { useContext } from 'react'
import Space from '../atoms/Space'
import { View } from '../other/html'
import ListLeftColumn from './item/ListLeftColumn'
import { ItemContext, ItemDispatchContext } from 'src/contexts/itemContext'
import ArchivedPriceColumn from './item/ArchivedPriceColumn'

const ArchivedItem = (): JSX.Element => {
  const itemContext = useContext(ItemContext)
  const dispatchItemContext = useContext(ItemDispatchContext)

  if (itemContext === null || dispatchItemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }

  const { index, id } = itemContext
  const backgroundColor = (i: number): string => (i % 2 === 0 ? 'bg-lightGrey' : 'bg-white')

  return (
    <View
      className={`shadow-bothSmall  mb-4 ${backgroundColor(index)} rounded-2`}
      onClick={() => {
        dispatchItemContext({ type: 'EXPAND_VIEW' })
      }}>
      <Space y={2} />
      <View className="flex justify-between">
        <ListLeftColumn showLikeIcon={false} showDealersIcon={false} offerUrl={`/browsing/offer/${id}`} />
        <ArchivedPriceColumn viewType="sold" />
      </View>
      <Space y={2} />
    </View>
  )
}

export default React.memo(ArchivedItem)
